import type { BaseEventData } from '../base.event';
import type {
  BaseQuoteEventData,
  QuoteWithCoveragePayload,
  QuoteWithPremiumPayload,
} from './base-quote.event';

type QuoteStartedOrProductSelectedPayload = BaseEventData & BaseQuoteEventData;

type QuoteQuestionsSubmittedPayload = BaseEventData &
  BaseQuoteEventData &
  QuoteWithCoveragePayload;

type QuoteCartOrRequestOrCustomizePayload = BaseEventData &
  BaseQuoteEventData &
  QuoteWithCoveragePayload &
  QuoteWithPremiumPayload & {
    quoteId: string;
    quoteNumber?: string;
  };

/**
 * Canonical quote-domain event names for {@link Analytics.track}.
 *
 * Implemented as a `const` object (not a string enum) so values are true string-literal types,
 * there is no extra TypeScript enum emit, and the same object doubles as the runtime namespace
 * for `analytics.track(QuoteAnalyticsEvents.STARTED, …)`.
 */
export const QuoteAnalyticsEvents = {
  STARTED: 'quote.started',
  PRODUCT_SELECTED: 'quote.product_selected',
  QUESTIONS_SUBMITTED: 'quote.questions_submitted',
  ADDED_TO_CART: 'quote.added_to_cart',
  REQUESTED: 'quote.requested',
  CUSTOMIZED: 'quote.customized',
} as const;

export type QuoteAnalyticsEventName =
  (typeof QuoteAnalyticsEvents)[keyof typeof QuoteAnalyticsEvents];

export type QuoteAnalyticsEventMap = {
  [QuoteAnalyticsEvents.STARTED]: QuoteStartedOrProductSelectedPayload;
  [QuoteAnalyticsEvents.PRODUCT_SELECTED]: QuoteStartedOrProductSelectedPayload;
  [QuoteAnalyticsEvents.QUESTIONS_SUBMITTED]: QuoteQuestionsSubmittedPayload;
  [QuoteAnalyticsEvents.ADDED_TO_CART]: QuoteCartOrRequestOrCustomizePayload;
  [QuoteAnalyticsEvents.REQUESTED]: QuoteCartOrRequestOrCustomizePayload;
  [QuoteAnalyticsEvents.CUSTOMIZED]: QuoteCartOrRequestOrCustomizePayload;
};
